import React, {Component} from 'react'
import {FormattedMessage} from "react-intl";
import {AppContext, AccountFeatures} from '@lightspeed-invoicing/core-client/frontend';

class FooterContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            brandingFeature: this.props.showBranding,
        }
    }

    getBrandingTextColor() {
        const darkColor = this.state.brandingFeature ? '#343a40' : '#6c757d'
        if (!this.props.variables) {
            return darkColor
        }
        const hexcolor = this.props.variables.global.backgroundColor.replace("#", "");
        var r = parseInt(hexcolor.substr(0, 2), 16);
        var g = parseInt(hexcolor.substr(2, 2), 16);
        var b = parseInt(hexcolor.substr(4, 2), 16);
        var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return (yiq >= 128) ? darkColor : 'white';
    }

    render() {
        const brandingTextColor = this.getBrandingTextColor()
        const isWhite = brandingTextColor === 'white'
        return (
            !this.state.brandingFeature &&
                <div className="flex flex-column mt-2 mb-2"
                     style={{"fontFamily": "Work Sans", color: brandingTextColor}}>
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="d-flex flex-row">
                            <div style={{height: "40px", "paddingTop": "9px"}}>
                                <FormattedMessage
                                    id="document.powered_by_link_image"
                                    defaultMessage="Powered by"
                                />
                            </div>
                            <a href="https://www.quotemachine.com?utm_source=QM-Branding&utm_medium=QM-Document&utm_campaign=In-App-Branding"
                               target="_blank" className="d-flex align-items-center">
                                <img
                                    src={isWhite ? '/images/QuoteM_horizontal_allwhite.png' : '/images/QuoteM_horizontal_flat.png'}
                                    height={isWhite ? '25px' : '40px'} className={isWhite ? 'pl-2' : ''}/>
                            </a>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                        <small>
                            <FormattedMessage
                                id="settings.documents.template.footer.catch_phrase"
                                defaultMessage="Build your own personalized quotes and invoices in seconds with QuoteMachine. {link}"
                                values={{
                                    link: <a
                                        href="https://www.quotemachine.com?utm_source=QM-Branding&utm_medium=QM-Document&utm_campaign=In-App-Branding"
                                        target="_blank" className="ml-1">
                                        <FormattedMessage
                                            id="settings.documents.template.footer.get_started"
                                            defaultMessage="Get Started"
                                        />
                                    </a>
                                }}
                            />
                        </small>
                    </div>
                </div>
        );
    }
}

export default FooterContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/footer/section.component.jsx